import rocketChatService from "../services/rocketChatService";
import { ElMessage } from 'element-plus';

export function loginApi(data) {
  return rocketChatService({
    url: "/login",
    method: "post",
    data,
  });
}

export function methodCallApi(apiName, method, data) {
  return rocketChatService({
    url: `/method.call/${apiName}`,
    method,
    data
  });
}

// Create a new Rocket.Chat user
export function createUserApi(userData) {
  return rocketChatService({
    url: "/users.create",
    method: "post",
    data: {
      name: userData.name,
      username: userData.username,
      password: userData.password,
      email: userData.email || `${userData.username}@patient.local`,
      verified: true,
      requirePasswordChange: false,
      sendWelcomeEmail: false,
      roles: ['user']
    }
  });
}

// Create a direct message room with a patient
export function createPatientRoomApi(patientUsername) {
  return rocketChatService({
    url: "/im.create",
    method: "post",
    data: {
      username: patientUsername
    }
  });
}

// Create a channel for patient
export function createPatientChannelApi(channelName, patientData) {
  return rocketChatService({
    url: "/channels.create",
    method: "post",
    data: {
      name: channelName,
      description: `Patient room for ${patientData.firstName} ${patientData.lastName}`,
      readOnly: false,
      broadcast: false
    }
  });
}

export function getSubscriptionsApi() {
  return rocketChatService({
    url: "/subscriptions.get",
    method: "get",
  });
}

export function markChannelAsReadApi(roomId) {
  return rocketChatService({
    url: "/subscriptions.read",
    method: "post",
    data: {
      rid: roomId
    }
  });
}

export function getPegBoardListApi(customer_id,clinic_id,patient_id) {
  return rocketChatService({
    url: "/pegboard",
    method: "get",
    params: {
      customer_id,
      clinic_id,
      patient_id
    }
  });
}


export function pinCardApi(customer_id, clinic_id, patient_id, cardData) {
  return rocketChatService({
    url: `/pegboard/pin?customer_id=${customer_id}&clinic_id=${clinic_id}&patient_id=${patient_id}`,
    method: "post",
    data: {
      customer_id,
      clinic_id,
      patient_id,
      category: cardData.category,
      entity_type: cardData.entity_type,
      entity_id: cardData.entity_id ?? "",
      metadata: cardData.metadata || {}
    }
  });
}


export function unpinCardApi(customer_id, clinic_id, patient_id, cardId) {
  return rocketChatService({
    url: `/pegboard/unpin?customer_id=${customer_id}&clinic_id=${clinic_id}&patient_id=${patient_id}&card_id=${cardId}`,
    method: "delete"
  });
}

export function updateCardOrderApi(customer_id, clinic_id, patient_id, newCardOrderIds,pegboardCardVersion) {
  return rocketChatService({
    url: "/pegboard/reorder",
    method: "put",
    data: {
      customer_id,
      clinic_id,
      patient_id,
      card_ids: newCardOrderIds,
      version: pegboardCardVersion
    }
  });
}

/**
 * Check communication channel readiness for a patient
 * @param {string} patient_id - Patient ID
 * @param {string} clinic_id - Clinic ID
 * @param {string} channel - Channel type (e.g., 'sms', 'email', 'chat')
 * @returns {Promise} Channel readiness status
 */
export function getChannelReadinessApi(patient_id, clinic_id, channel) {
  return rocketChatService({
    url: `/communication/channel-readiness?patient_id=${patient_id}&clinic_id=${clinic_id}&channel=${channel}`,
    method: "get"
  });
}

/**
 * Send a message to a RocketChat room
 * @param {Object} messageData - Message data including rid, msg, attachments, etc.
 * @returns {Promise} Message send response
 */
export function sendMessageApi(messageData) {
  return rocketChatService({
    url: "/messages",
    method: "post",
    data: { message: messageData }
  });
}